import { render, staticRenderFns } from "./resendEmail.vue?vue&type=template&id=9072006e"
import script from "./resendEmail.vue?vue&type=script&lang=js"
export * from "./resendEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports